import { EventEmitter } from 'eventemitter3';
export class MetricsManager extends EventEmitter {
    static instance;
    constructor() {
        super();
    }
    static getInstance() {
        if (!MetricsManager.instance) {
            MetricsManager.instance = new MetricsManager();
        }
        return MetricsManager.instance;
    }
    logMetric(metric, value) {
        this.emit('metricLogged', metric, value);
    }
}
